import React, {useState} from 'react';
import { useHistory } from "react-router";
import { Container, Paragraph, ButtonContainer, WarningBox, AccountBox, BoxTitle, WarningIcon, DeleteStyledButton } from './DeleteAccount.styles';
import { Button } from '@material-ui/core';
import DeleteModal from '../../../components/DeleteModal/DeleteModal';
import useActionApi from "../../../hooks/useActionApi";
import Api from "../../../api";
import FixedLoader from "../../../components/FixedLoader/FixedLoader";
import FixedError from "../../../components/FixedError/FixedError";
import { TopBarRedesigned } from "components/TopBarRedesigned";
import {usePersistedState} from "../../../hooks";
import {HygienistProps} from "utils/types";
import {entities} from "../../../reduxStore";
import { SUPPORT_EMAIL } from "utils/constants";
import clsx from 'clsx';


// @ts-ignore
const TempStars = window.TempStars

declare let window: any
declare let cordova: any

const HygienistDeleteAccount: React.FC = () => {
  const history = useHistory();
  const hygienist = usePersistedState<HygienistProps>({
    entityName: entities.hygienist
})[0];

const [deleteUserLoading, deleteUserError, deleteUserAccount] = useActionApi({
  apiMethod: Api.deleteUser,
  onSuccess: (response) => {},
});

const helpEmail = SUPPORT_EMAIL.US;

const handleContactSupport = () => {
  if (window.cordova && window.cordova.platformId === 'ios') {
    cordova.plugins.email.open({
        to:      helpEmail,
        subject: '',
        body:    ''
    });
  } else {
    window.open(`mailto:${helpEmail}`, '_system');
  }
};

return (
  <Container>
    <TopBarRedesigned
      title={'Delete your account?'}
      onBack={() => {
        history.goBack();
      }}
    />

    <WarningBox>
      <BoxTitle $titleColor="var(--primary-main)"><WarningIcon $iconColor="var(--primary-main)" /> Critical Warning:</BoxTitle>
      <Paragraph>
        Are you sure you want to delete your account? This action cannot be undone.
      </Paragraph>
      <ul>
        <li>You will lose access to all your data and past records</li>
        <li>You won't be able to log in or use any TempStars services</li>
        <li>Your personal information will be removed from our active systems</li>
      </ul>
    </WarningBox>
    {hygienist.status >-2 && hygienist.completedJobs===0 && (
    <AccountBox $backgroundColor="var(--background-success)" $borderColor="var(--info-main)">
      <BoxTitle $titleColor="var(--primary-blue)">New User Account</BoxTitle>
      <Paragraph>
      It looks like your account is new and you haven’t completed any shifts. Consider contacting support to resolve any issues before deletion - we’ll be happy to help answer any questions and get you on your way!
      </Paragraph>
    </AccountBox>
    )}
    {hygienist.status >-2 && hygienist.completedJobs > 0 && (
      <AccountBox $backgroundColor="var(--background-alternate)" $borderColor="var(--warning-main)">
        <BoxTitle $titleColor="var(--warning-main)"><WarningIcon $iconColor="var(--warning-main)" /> Active User Account</BoxTitle>
        <Paragraph>
        Your account is Active and you have an established track record for shifts and reviews.  <b>You will lose all this data, work history, & ratings.</b> We strongly recommend contacting support to resolve any issues before considering deletion.           </Paragraph>
        <Paragraph>
        Our support team is here to help you resolve any issues and assist with anything you need. Please consider contacting support before making the irreversible decision to delete your account.          </Paragraph>
      </AccountBox>
    )}
      {hygienist.status < -1 && hygienist.completedJobs > 0 && (
      <AccountBox $backgroundColor="var(--background-alternate)" $borderColor="var(--warning-main)">
        <BoxTitle $titleColor="var(--warning-main)"><WarningIcon $iconColor="var(--warning-main)" /> Account On Hold</BoxTitle>
        <Paragraph>
        Your account is currently On Hold. Deleting it will not lift the Hold status, and you won’t be able to create a new account. We strongly recommend contacting support to resolve any issues before considering deletion. Our support team is here to help you resolve any issues and potentially reinstate your account. Please consider contacting support before making the irreversible decision to delete your account.
        </Paragraph>
      </AccountBox>
    )}
    <ButtonContainer>
      <DeleteStyledButton
        onClick={handleContactSupport}
        variant="outlined"
        color="primary"
        size="large"
        className={clsx("deleteButton", "no-fastclick")}
      >
        Contact Support
      </DeleteStyledButton>
      <DeleteStyledButton
        onClick={()=>history.push('hygienistDeleteAccountSecondStep')}
        variant="contained"
        color="secondary"
        size="large"
        className={clsx("deleteButton", "no-fastclick")}
      >
        Continue to Delete
      </DeleteStyledButton>
    </ButtonContainer>
    <FixedLoader loading={deleteUserLoading} />
    <FixedError error={deleteUserError} />
  </Container>
);
};

export default HygienistDeleteAccount;
